// extracted by mini-css-extract-plugin
export default {"main":"RatingHistoryPopOver_main__T2l+T","showMore":"RatingHistoryPopOver_showMore__yvTv6 font-sm-medium"};